import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ILabelValueConstant} from '../../../../constants/constants';


@Component({
  selector: 'app-validation-modal',
  templateUrl: './validation-modal.component.html',
  styleUrls: ['./validation-modal.component.scss']
})
export class ValidationModalComponent implements OnInit {
  @Input() validations: IValidationForm;
  public validationForm: UntypedFormGroup;
  public searchable: boolean = false;
  public readonly: boolean = false;
  public editValidation: Array<ILabelValueConstant> = [
    { value: 'numbers', label: 'Numbers' },
    { value: 'letters', label: 'Letters' },
    { value: 'numbers_letters', label: 'Numbers and Letters' },
    { value: 'email', label: 'Email' },
    { value: 'custom_regex_validation', label: 'Custom Validation' }
  ];

  public numberValidationtype: Array<ILabelValueConstant> = [
    { value: 'numbers_range', label: 'Number range' },
    { value: 'numbers_characters', label: 'Number of characters' },
  ];
  constructor(public _formBuilder: UntypedFormBuilder, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.initValidationForm(this.validations);
  }


  /**
   * Apply validation on parent section
   */
  applyValidation(){
    this.activeModal.close({validations: this.validationForm.value});
  }




  /**
   * Init validation form with data;
   * @param data 
   */
  initValidationForm(data:IValidationForm) {
    this.validationForm = this._formBuilder.group({
      id: [data.id ?? 0],
      index: [data.index ?? -1],
      type: [data.type ?? null],
      validation_type: [data.validation_type ?? null],
      number_validation_type: [data.number_validation_type ?? null],
      min: [data.min ?? null],
      max: [data.max ?? null],
      decimals: [data.decimals ?? null],
      regular_expression: [data.regular_expression ?? null],
      validation_help_text: [data.validation_help_text ?? null],
    });
      // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    this.validationForm.get('validation_type').valueChanges.subscribe((value) => {
      if(value == null){
        this.validationForm.patchValue({
          validation_type: null,
          number_validation_type: null,
          min: null,
          max: null,
          decimals: null,
          regular_expression: null,
          validation_help_text: null,
        });
      }
      else if (value == 'numbers') {
        that.validationForm.get('number_validation_type').setValidators(Validators.required);
      } 
      else {
        that.validationForm.get('number_validation_type').setValidators(null);
      }
    });
  }


  /** Get validation form control */
  get vForm() {
    return this.validationForm.controls;
  }

}

export interface IValidationForm {
id:number, index:number, type:string, validation_type:string, number_validation_type:string, min:number, max:number, decimals:number, regular_expression:string, validation_help_text:string
}
